var exports = {
  "n": "xe533113f--d0235f--tabs-container",
};

module.exports = exports;
